import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompaniesRoutingModule } from './companies-routing.module';
import { CompaniesService } from './companies.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { CompaniesComponent } from './companies.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ValidationService } from '../form-validation/validation.service';
import { NewCompanyComponent } from './new-company/new-company.component';


@NgModule({
  declarations: [
    CompaniesComponent,
    NewCompanyComponent
  ],
  imports: [
    CommonModule,
    CompaniesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxPaginationModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers:[CompaniesService, ValidationService]
})
export class CompaniesModule { }
